module.exports = __webpack_public_path__ + "img/sms.783aac21.svg";